/**
 * Explore Service
 * API calls for constellation-based music discovery
 */

import { post, get, del } from '../lib/api-client';
import type {
  ExploreRequest,
  ExploreResponse,
  SavedConstellation,
} from '../types/explore.types';
import type { ApiResponse } from '../types/api.types';

/**
 * Generate music recommendations from constellation
 */
export async function generateExplore(
  request: ExploreRequest
): Promise<ExploreResponse> {
  const response = await post<ExploreResponse['data']>('/explore/generate', request);
  return {
    success: response.success,
    data: response.data!,
    error: response.error?.message,
  };
}

/**
 * Save constellation preset
 */
export async function saveConstellation(
  name: string,
  description: string | undefined,
  nodes: ExploreRequest['nodes'],
  vibe: ExploreRequest['vibe']
): Promise<SavedConstellation> {
  const response = await post<SavedConstellation>('/explore/save', {
    name,
    description,
    nodes,
    vibe,
  });
  return response.data!;
}

/**
 * Get user's saved constellations
 */
export async function getSavedConstellations(): Promise<SavedConstellation[]> {
  const response = await get<SavedConstellation[]>('/explore/saved');
  return response.data || [];
}

/**
 * Delete saved constellation
 */
export async function deleteConstellation(id: string): Promise<void> {
  await del(`/explore/saved/${id}`);
}

/**
 * Get example constellations (public)
 */
export async function getExampleConstellations(): Promise<SavedConstellation[]> {
  const response = await get<SavedConstellation[]>('/explore/examples');
  return response.data || [];
}
